// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3HuAL","resendInfoText":"OnGoingPaymentBox_resendInfoText__2J8y3"};